// Public: Returns the specified cookie, if present.
export function readCookie (name: string) {
  return decodeURIComponent(
    new RegExp(`(?:^|; )${encodeURIComponent(name)}=([^;]*)`).exec(document.cookie)?.[1] || '',
  )
}
